import { Action } from '@ngrx/store';
import { CalOmsExtractWorkspaceModel } from "../../models/CalOmsExtractWorkspaceModel";

export const GET_SELECTED_EXTRACT_SUCCESS_ACTION = '[Extracts] Get Selected Extract Success Action';

export class GetSelectedExtractSuccessAction implements Action {
  readonly type: string;

  constructor(public payload: { items: CalOmsExtractWorkspaceModel[] }) {
    this.type = GET_SELECTED_EXTRACT_SUCCESS_ACTION;
  }
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GetSelectedExtractSuccessAction.ts